import script from "./analysis-skeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./analysis-skeleton.vue?vue&type=script&setup=true&lang=js"

import "./analysis-skeleton.vue?vue&type=style&index=0&id=2f5679b8&lang=less&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f5679b8"]])

export default __exports__